import React, { useEffect, useState } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { Button } from 'react-toolbox/lib/button'

import styles from './styles.scss'

import {
    applyChangesToProjectsAction,
    toggleNotify
} from '../actions'

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
        applyChanges: (formDetails, formType) => dispatch(applyChangesToProjectsAction(formDetails, formType)),
        toggleNotify: (toggle) => dispatch(toggleNotify(toggle))
    }
}

const checkFormDetails = (form, toggleNotify) => {
    let type = Object.keys(form)[0]
    let anyAnswers = false
    if(type === "schedule") {
        let fields = form.schedule
        if (Object.keys(fields).length > 0) {
            anyAnswers = true
        }
    } else {
        let fields = Object.values(form)
        fields.forEach((field) => {
            if (field.length > 0) {
                anyAnswers = true
            }
        })
    }
    if (anyAnswers) {
        toggleNotify(anyAnswers)
    }
    return anyAnswers
}

const SubmitButton = ( { formDetails, formType, applyChanges, cancelState, numberOfProjects, toggleNotify }) => {
    return (
        <div>
            <Button 
                label={numberOfProjects > 0 ? `Apply (${numberOfProjects})`: 'Apply'} 
                onClick={() => applyChanges(formDetails, formType)}
                icon='arrow_circle_up'
                disabled={!checkFormDetails(formDetails, toggleNotify)}
                primary
            />
            <Button 
                label="Clear"
                onClick={() => cancelState()}
                disabled={!checkFormDetails(formDetails, toggleNotify)}
                secondary="true"
            />
        </div>
    )
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)

const enhance = compose(
    withConnect,
    withStyle
)

export default enhance(SubmitButton)